// extracted by mini-css-extract-plugin
module.exports = {"menus":"index_menus_2zIzz","icon":"index_icon_2fL6Z","leftTitle":"index_leftTitle_1mTlf","content":"index_content_eWENr","rightTitle":"index_rightTitle_6M5PS"};